import { Grid, GridProps } from "@chakra-ui/react";

/**
 * A layout designed for use with the DetailSidebar
 */
export const SidebarLayout = (props: GridProps) => {
  return <Grid templateColumns="1fr 250px" px={4} py={1} gap={4} {...props} />;
};
